// Immagine verticale 1080x1920 per le storie Instagram/WhatsApp: "<Nome> è Founder Readoo".
const W = 1080, H = 1920, BRAND = "#E86A4C", BG = "#0F0E0D", INK = "#F4F1EC", MUTED = "#A39C93";

function fit(ctx, text, weight, family, max, start) {
  let size = start;
  do { ctx.font = `${weight} ${size}px "${family}"`; size -= 4; } while (ctx.measureText(text).width > max && size > 40);
  return size + 4;
}

function pill(ctx, x, y, w, h) {
  const r = h / 2;
  ctx.moveTo(x + r, y);
  ctx.lineTo(x + w - r, y);
  ctx.arc(x + w - r, y + r, r, -Math.PI / 2, Math.PI / 2);
  ctx.lineTo(x + r, y + h);
  ctx.arc(x + r, y + r, r, Math.PI / 2, -Math.PI / 2);
  ctx.closePath();
}

export async function founderStoryBlob(name) {
  await Promise.all([
    document.fonts.load('600 160px "Barlow Semi Condensed"'),
    document.fonts.load('700 40px "JetBrains Mono"'),
    document.fonts.load('500 44px "Plus Jakarta Sans"'),
  ]).catch(() => {});
  const c = document.createElement("canvas");
  c.width = W; c.height = H;
  const ctx = c.getContext("2d");
  ctx.fillStyle = BG; ctx.fillRect(0, 0, W, H);
  ctx.fillStyle = "rgba(232,106,76,0.18)";
  ctx.beginPath(); ctx.arc(W - 60, 260, 420, 0, Math.PI * 2); ctx.fill();
  ctx.fillStyle = "rgba(232,106,76,0.10)";
  ctx.beginPath(); ctx.arc(80, H - 300, 360, 0, Math.PI * 2); ctx.fill();

  ctx.textBaseline = "alphabetic";
  ctx.fillStyle = INK; ctx.font = '600 96px "Barlow Semi Condensed"';
  ctx.fillText("Readoo", 90, 220);
  const wm = ctx.measureText("Readoo").width;
  ctx.fillStyle = BRAND; ctx.beginPath(); ctx.arc(90 + wm + 22, 208, 13, 0, Math.PI * 2); ctx.fill();

  ctx.font = '700 38px "JetBrains Mono"';
  const label = "FOUNDER READOO", lw = ctx.measureText(label).width;
  ctx.fillStyle = BRAND;
  ctx.beginPath();
  pill(ctx, 90, 760, lw + 80, 84);
  ctx.fill();
  ctx.fillStyle = BG; ctx.fillText(label, 130, 815);

  const who = (name || "Io").trim();
  ctx.fillStyle = INK;
  fit(ctx, who, 600, "Barlow Semi Condensed", W - 180, 200);
  ctx.fillText(who, 90, 1060);
  fit(ctx, "è Founder di Readoo.it", 600, "Barlow Semi Condensed", W - 180, 120);
  ctx.fillText("è Founder di Readoo.it", 90, 1200);

  ctx.fillStyle = MUTED; ctx.font = '500 44px "Plus Jakarta Sans"';
  ctx.fillText("Tra i primi lettori di Readoo:", 90, 1310);
  ctx.fillText("le notizie importanti del giorno.", 90, 1370);

  ctx.fillStyle = INK; ctx.font = '700 44px "JetBrains Mono"';
  ctx.fillText("readoo.it/founder", 90, H - 200);
  ctx.fillStyle = MUTED; ctx.font = '500 28px "Plus Jakarta Sans"';
  ctx.fillText("Riconoscimento simbolico e gratuito.", 90, H - 140);
  return new Promise((res) => c.toBlob(res, "image/png"));
}
